import type { ComponentStyleConfig } from "@chakra-ui/theme";

export const Link: ComponentStyleConfig = {
	baseStyle: {
		fontWeight: 500,
		fontFamily: ["SF Pro", "Roboto"],
	},
	sizes: {
		lg: {
			fontSize: {
				base: "md",
				lg: "lg",
			},
			lineHeight: {
				base: "xl",
				lg: "2xl",
			},
		},
		md: {
			fontSize: {
				base: "sm",
				lg: "md",
			},
			lineHeight: {
				base: "xl",
				lg: "xl",
			},
		},
		sm: {
			fontSize: {
				base: "xs",
				lg: "sm",
			},
			lineHeight: {
				base: "lg",
				lg: "xl",
			},
		},
	},
};
